<template>
  <div style="text-align: right;width: 100%;">
    <v-btn text
    color="primary"
    @click.native="resetPass"
    :loading="resetting"
    :disabled="resetdisabled" >Reset password <v-icon v-if= "resetdisabled && !resetting">check</v-icon></v-btn>
  </div>
</template>
<script>
import Auth from '@/core/auth';
export default {
  name: 'resetpass',
  props: ['user'],
  data () {
    return {
      resetdisabled: false,
      resetting: false
    }
  },
  watch: {
    user () {
      this.init();
    }
  },
  computed: {

  },
  methods: {
    resetPass () {
      var app = this;
      console.log('resetPass driver id', this.user.email)
      this.resetdisabled = this.resetting = true;
      if (this.user.id) {
        console.log('resetPass driver id', this.user.id)
        Auth.resetpass(app, {
          id: this.user.id,
          email: this.user.email
        }, function () {
          app.resetting = false;
        });
      }
    },
    init () {
      this.resetdisabled = false;
      this.resetting = false;
    }
  },
  created () {

  }
}
</script>
